import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import AdminOverview from './AdminOverview';
import AdminUsers from './AdminUsers';
import AdminBusinesses from './AdminBusinesses';
import AdminCategories from './AdminCategories';
import AdminCities from './AdminCities';
import AdminAds from './AdminAds';
import AdminEnquiries from './AdminEnquiries';
import AdminVisits from './AdminVisits';
import AdminReports from './AdminReports';
import AdminSettings from './AdminSettings';
import Profile from '../Profile';

const LINKS = [
  { to: '/admin', end: true, label: 'Overview',    testid: 'overview' },
  { to: '/admin/users',       label: 'Users',       testid: 'users' },
  { to: '/admin/businesses',  label: 'Businesses',  testid: 'businesses' },
  { to: '/admin/categories',  label: 'Categories',  testid: 'categories' },
  { to: '/admin/cities',      label: 'Cities',      testid: 'cities' },
  { to: '/admin/ads',         label: 'Advertisements', testid: 'ads' },
  { to: '/admin/enquiries',   label: 'Enquiries',   testid: 'enquiries' },
  { to: '/admin/visits',      label: 'Field visits', testid: 'visits' },
  { to: '/admin/reports',     label: 'Reports',     testid: 'reports' },
  { to: '/admin/settings',    label: 'Settings',    testid: 'settings' },
  { to: '/admin/profile',     label: 'My profile',  testid: 'profile' },
];

export default function AdminLayout() {
  return (
    <div className="ap-shell" data-testid="admin-shell">
      <Sidebar title="Admin" links={LINKS} />
      <main className="ap-content">
        <Routes>
          <Route index element={<AdminOverview />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="businesses" element={<AdminBusinesses />} />
          <Route path="categories" element={<AdminCategories />} />
          <Route path="cities" element={<AdminCities />} />
          <Route path="ads" element={<AdminAds />} />
          <Route path="enquiries" element={<AdminEnquiries />} />
          <Route path="visits" element={<AdminVisits />} />
          <Route path="reports" element={<AdminReports />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="profile" element={<Profile />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </main>
    </div>
  );
}
